import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { Availability, Availability_$reflection } from "../../../../Logos.Shared/Domain/Entity/User.fs.js";
import { union_type, bool_type, class_type, record_type, string_type, lambda_type, unit_type, list_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Busy, Busy_$reflection } from "../../SharedView.fs.js";
import { ofArray, singleton, map, empty } from "../../../fable_modules/fable-library-js.4.19.3/List.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { createObj, equals } from "../../../fable_modules/fable-library-js.4.19.3/Util.js";
import { createElement } from "react";
import React from "react";
import { join, printf, toConsole } from "../../../fable_modules/fable-library-js.4.19.3/String.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { Daisy_modernInput, Daisy_modernCheckbox, Daisy_error } from "../../Component/Component.fs.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.4.2.1/./DaisyUI.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.8.0/./Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, map as map_1, delay, toList } from "../../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { DayOfWeek_toString } from "../../../AppDomain/Util.fs.js";
import { parse, toString } from "../../../fable_modules/fable-library-js.4.19.3/TimeOnly.js";

export class State extends Record {
    constructor(WeeklyAvailability, OnWeeklyAvailabilityChange, Errors, IsBusy) {
        super();
        this.WeeklyAvailability = WeeklyAvailability;
        this.OnWeeklyAvailabilityChange = OnWeeklyAvailabilityChange;
        this.Errors = Errors;
        this.IsBusy = IsBusy;
    }
}

export function State_$reflection() {
    return record_type("Presentation.Pages.User.UserAvailability.State", [], State, () => [["WeeklyAvailability", list_type(Availability_$reflection())], ["OnWeeklyAvailabilityChange", lambda_type(list_type(Availability_$reflection()), unit_type)], ["Errors", list_type(string_type)], ["IsBusy", Busy_$reflection()]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetStartChanged", "SetFinishChanged", "SetEnabled", "ApiError"];
    }
}

export function Msg_$reflection() {
    return union_type("Presentation.Pages.User.UserAvailability.Msg", [], Msg, () => [[["Item1", Availability_$reflection()], ["Item2", class_type("System.TimeOnly")]], [["Item1", Availability_$reflection()], ["Item2", class_type("System.TimeOnly")]], [["Item1", Availability_$reflection()], ["Item2", bool_type]], [["Item", class_type("System.Exception")]]]);
}

export function init(weeklyAvailability, onWeeklyAvailabilityChange) {
    return [new State(weeklyAvailability, onWeeklyAvailabilityChange, empty(), new Busy(0, [])), Cmd_none()];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            const availability_1 = msg.fields[0];
            const updated_1 = new Availability(availability_1.Id, availability_1.DayOfWeek, availability_1.StartTime, msg.fields[1], availability_1.IsEnabled);
            const updatedWeeklyAvailability_1 = new State(map((x_1) => {
                if (equals(x_1, availability_1)) {
                    return updated_1;
                }
                else {
                    return x_1;
                }
            }, state.WeeklyAvailability), state.OnWeeklyAvailabilityChange, state.Errors, state.IsBusy);
            state.OnWeeklyAvailabilityChange(updatedWeeklyAvailability_1.WeeklyAvailability);
            return [updatedWeeklyAvailability_1, Cmd_none()];
        }
        case 2: {
            const availability_2 = msg.fields[0];
            const updated_2 = new Availability(availability_2.Id, availability_2.DayOfWeek, availability_2.StartTime, availability_2.FinishTime, msg.fields[1]);
            const updatedWeeklyAvailability_2 = new State(map((x_2) => {
                if (equals(x_2, availability_2)) {
                    return updated_2;
                }
                else {
                    return x_2;
                }
            }, state.WeeklyAvailability), state.OnWeeklyAvailabilityChange, state.Errors, state.IsBusy);
            state.OnWeeklyAvailabilityChange(updatedWeeklyAvailability_2.WeeklyAvailability);
            return [updatedWeeklyAvailability_2, Cmd_none()];
        }
        case 3:
            return [new State(state.WeeklyAvailability, state.OnWeeklyAvailabilityChange, singleton(msg.fields[0].message), state.IsBusy), Cmd_none()];
        default: {
            const availability = msg.fields[0];
            const updated = new Availability(availability.Id, availability.DayOfWeek, msg.fields[1], availability.FinishTime, availability.IsEnabled);
            const updatedWeeklyAvailability = new State(map((x) => {
                if (equals(x, availability)) {
                    return updated;
                }
                else {
                    return x;
                }
            }, state.WeeklyAvailability), state.OnWeeklyAvailabilityChange, state.Errors, state.IsBusy);
            state.OnWeeklyAvailabilityChange(updatedWeeklyAvailability.WeeklyAvailability);
            return [updatedWeeklyAvailability, Cmd_none()];
        }
    }
}

export function IndexView(props) {
    let elems_1, children_2, children, children_10;
    toConsole(printf("-----> %A"))(props.WeeklyAvailability);
    let patternInput;
    const init_1 = init(props.WeeklyAvailability, props.onWeeklyAvailabilityChange);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, update, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const children_13 = ofArray([Daisy_error(state_1.Errors), createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "table-zebra"], ["className", "table-xs"], ["className", "table-pin-rows"], ["className", "table-pin-cols"], ["className", join(" ", ["flex", "w-full", "ml-2", "mr-2"])], (elems_1 = [(children_2 = singleton((children = ofArray([createElement("th", {
        width: 15 + "%",
        children: "Day of week",
    }), createElement("th", {
        width: 5 + "%",
        children: "Enabled",
    }), createElement("th", {
        width: 40 + "%",
        children: "Start",
    }), createElement("th", {
        width: 40 + "%",
        children: "Finish",
    })]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))), createElement("thead", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    })), (children_10 = toList(delay(() => map_1((jobSchedule) => {
        let elems, children_4, children_6, children_8;
        return createElement("tr", createObj(ofArray([["className", join(" ", ["align-text-top"])], (elems = [createElement("td", {
            children: [DayOfWeek_toString(jobSchedule.DayOfWeek)],
        }), (children_4 = singleton(Daisy_modernCheckbox(ofArray([["checked", jobSchedule.IsEnabled], ["onChange", (ev) => {
            let tupledArg;
            dispatch((tupledArg = [jobSchedule, ev.target.checked], new Msg(2, [tupledArg[0], tupledArg[1]])));
        }]]))), createElement("td", {
            children: reactApi.Children.toArray(Array.from(children_4)),
        })), (children_6 = toList(delay(() => (jobSchedule.IsEnabled ? singleton_1(Daisy_modernInput(ofArray([["type", "time"], ["value", toString(jobSchedule.StartTime)], ["disabled", !jobSchedule.IsEnabled], ["onInput", (e_1) => {
            dispatch(new Msg(0, [jobSchedule, parse(e_1.target.value)]));
        }]]))) : empty_1()))), createElement("td", {
            children: reactApi.Children.toArray(Array.from(children_6)),
        })), (children_8 = toList(delay(() => (jobSchedule.IsEnabled ? singleton_1(Daisy_modernInput(ofArray([["type", "time"], ["value", toString(jobSchedule.FinishTime)], ["disabled", !jobSchedule.IsEnabled], ["onInput", (e_2) => {
            dispatch(new Msg(1, [jobSchedule, parse(e_2.target.value)]));
        }]]))) : empty_1()))), createElement("td", {
            children: reactApi.Children.toArray(Array.from(children_8)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, state_1.WeeklyAvailability))), createElement("tbody", {
        children: reactApi.Children.toArray(Array.from(children_10)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))]);
    return createElement("div", {
        children: reactApi.Children.toArray(Array.from(children_13)),
    });
}

